import { AxiosError } from 'axios';

import { apiService } from '../../../shared/services/apiServices';
import { CLIENT_ERROR_MESSAGES } from '../errors/errorMessages';
import clientEndpoints from './clientEndpoints';

export interface FinalizeClientResult {
  success: boolean;
  error?: string;
}

const extractErrorMessage = (errorData: unknown, status?: number): string => {
  if (status === 403) {
    return CLIENT_ERROR_MESSAGES.NO_PERMISSION_TOOLTIP;
  }
  if (!errorData) {
    return CLIENT_ERROR_MESSAGES.DEFAULT_ERROR;
  }
  if (typeof errorData === 'string') {
    return errorData;
  }
  if (typeof errorData === 'object') {
    const apiError = errorData as { message?: string; error?: string };
    const msg = apiError.message || apiError.error;
    if (msg === 'Internal Server Error') {
      return CLIENT_ERROR_MESSAGES.UNEXPECTED_ERROR;
    }
    return msg || CLIENT_ERROR_MESSAGES.DEFAULT_ERROR;
  }
  return CLIENT_ERROR_MESSAGES.DEFAULT_ERROR;
};

export const finalizeClient = async (
  clientId: string
): Promise<FinalizeClientResult> => {
  try {
    const result = await apiService.postAPI(
      clientEndpoints.FINALIZE(clientId),
      {},
      { skipGlobalErrorRedirect: true }
    );

    if (result.error) {
      return {
        success: false,
        error: result.isNetworkError
          ? CLIENT_ERROR_MESSAGES.NETWORK_ERROR
          : extractErrorMessage(result.data, result.status),
      };
    }

    return { success: true };
  } catch (error) {
    if (error instanceof AxiosError) {
      const isNetworkError = !error.response && !!error.request;
      if (isNetworkError) {
        return { success: false, error: CLIENT_ERROR_MESSAGES.NETWORK_ERROR };
      }
      return {
        success: false,
        error: extractErrorMessage(error.response?.data),
      };
    }
    return {
      success: false,
      error:
        error instanceof Error
          ? error.message
          : CLIENT_ERROR_MESSAGES.UNEXPECTED_ERROR,
    };
  }
};
